gz-textarea {
  max-width: 50%;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-checkbox {
  width: auto;
}
